import {
  CardProps as MantineCardProps,
  Card as MantineCard,
  CardSectionProps as MantineCardSectionProps,
  CardSection as MantineCardSection,
} from '@mantine/core';

export type CardProps = MantineCardProps;

export type CardSectionProps = MantineCardSectionProps;

export const Card = MantineCard as typeof MantineCard;

Card.displayName = 'Card';

export const CardSection = MantineCardSection as typeof MantineCardSection;

CardSection.displayName = 'CardSection';
